import React from "react";
import "./impressum.css";

export default function Impressum() {
  return (
    <div className="impressum-page-container">
      <div className="impressum-card">
        <h1>Imprint</h1>
        <p>
          The imprint for these pages is - as with all websites that are part of the university - the{" "}
          <a
            href="https://www.uni-due.de/impressum/"
            target="_blank"
            rel="noopener noreferrer"
          >
            imprint of the university
          </a>
          , which you can find below. Contact information for this specific website can be found in the navigation under "Contact".
        </p>
      </div>

      <div className="impressum-card">
        <h2>Imprint</h2>
        <p>
          The University of Duisburg-Essen (UDE) is a public corporation under public law supported by the state of North Rhine-Westphalia. It bears the name "University of Duisburg-Essen" and uses this name in its logo.
        </p>
        <p>
          Responsible supervisory authority:
          <br />
          Ministry of Culture and Science of the State of North Rhine-Westphalia
          <br />
          Völkinger Straße 49
          <br />
          40221 Düsseldorf
        </p>
      </div>

      <div className="impressum-card">
        <h2>Address of the University of Duisburg-Essen</h2>
        <p>
          <strong>Campus Duisburg:</strong>
          <br />
          Forsthausweg 2
          <br />
          47057 Duisburg
          <br />
          Tel.: +49 203 379 0
        </p>
        <p>
          <strong>Campus Essen:</strong>
          <br />
          Universitätsstraße 2
          <br />
          45141 Essen
          <br />
          Tel.: +49 201 183 0
        </p>
      </div>

      <div className="impressum-card">
        <p>Legal Representation:</p>
        <h2>The Rector of the University of Duisburg-Essen</h2>
        <p>
          <strong>Prof. Dr. Barbara Albert</strong>
          <br />
          <a href="mailto:rektorin@uni-due.de">rektorin@uni-due.de</a>
        </p>
        <p>
          Campus Duisburg: Tel.: <br /> +49 203 37 92465
          <br /><br />
          Campus Essen: Tel.: <br /> +49 201 18 32000
        </p>
      </div>

      <div className="impressum-card">
        <h2>Editorial Responsibility for These Websites</h2>
        <p>
          The individual institutions, faculties, institutes and administrative offices of the University are responsible for the creation and maintenance of their websites themselves. The authors of the websites are responsible for the respective contents. If you have questions about one of these internet offerings, please contact the responsible author.
        </p>
        <p>
          The contact persons for this website can be reached at the e-mail address in the imprint of the central university websites.
        </p>
      </div>

      <div className="impressum-card">
        <h2>Technology / WWW Server of the Faculty</h2>
        <p>
          IT-Servicecenter der Fakultät für Wirtschaftswissenschaften
          <br /><br />
          <strong>Technik</strong>
          <br />
          Tel.: +49 201 18 32500
          <br />
          E-Mail: <a href="mailto:it@wiwi.uni-due.de">it@wiwi.uni-due.de</a>
        </p>
      </div>

      <div className="impressum-card">
        <h2>Font</h2>
        <p>
          This website uses the font Open Sans by Steve Matteson under the
          <a
            href="https://www.apache.org/licenses/LICENSE-2.0"
            target="_blank"
            rel="noopener noreferrer"
          >
            &nbsp;Apache 2.0 License
          </a>
          .
        </p>
      </div>

      <div className="impressum-card">
        <h2>Copyright</h2>
        <p>
          The University of Duisburg-Essen is the copyright holder of all contents and documents of pages that refer to this imprint. The contents are protected by copyright - copying or modifying them is only permitted with the permission of the copyright holder. This does not apply to copies of files on the user's own computer to view the pages with a browser. For all other contents on WWW servers of the University of Duisburg-Essen, the respective areas are editorially responsible.
        </p>
      </div>

      <div className="impressum-card">
        <h2>Reports of Abusive Use</h2>
        <p>
          If abusive uses originate from stations in the IP name range uni-due.de, uni-duisburg-essen.de, uni-duisburg.de or uni-essen.de, please send an e-mail to
          {" "}
          <a href="mailto:abuse@uni-due.de">abuse@uni-due.de</a>.
        </p>
      </div>

      <div className="impressum-card">
        <h2>Liability for Contents</h2>
        <p>
          The contents of the pages of the University of Duisburg-Essen were created with the greatest care. However, no guarantee is given for the accuracy, completeness and topicality of the contents.
        </p>
        <p>
          As a service provider, the UDE is responsible for its own contents on these pages in accordance with the general laws pursuant to § 7 para. 1 Telemediengesetz (TMG). However, pursuant to §§ 8-10 TMG, the University as a service provider is not obliged to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity. Obligations to remove or block the use of information in accordance with general laws remain unaffected. However, liability in this respect is only possible from the time of knowledge of a specific infringement. If corresponding infringements become known, the contents will be removed immediately.
        </p>
      </div>

      <div className="impressum-card">
        <h2>Liability for Links</h2>
        <p>
          This website contains links to third-party websites ("external links"). These websites are subject to the liability of their respective operators, so the University of Duisburg-Essen assumes no liability for these external contents. The linked pages were checked for possible legal violations at the time of linking. Illegal contents were not recognizable at the time of linking. However, a permanent content control of the linked pages is not reasonable without concrete indications of a legal violation, so the University of Duisburg-Essen hereby expressly distances itself from all contents of the linked/connected pages that have been changed after the linking. For illegal, incorrect or incomplete contents and in particular for damages that arise from the use or non-use of such information provided, only the provider of the page to which reference was made is liable, not the one who refers to the respective publication via links.
        </p>
      </div>
    </div>
  );
}
